<template>
  <div>
      <div class="comment-init">
          <div class="hide-btn" v-if="showComments" @click="hideComments">
              <span v-html="hideButtonText"></span>
          </div>
      </div>

      <template v-if="!loading">
          <template v-if="showComments">
              <edi-featured-comment
                  v-if="!!featuredComment"
                  :content-id="contentId"
                  :comment="featuredComment"
              />
              <edi-comment-section v-if="commentable" :comment-type="commentType" :content-id="contentId" />
              <div class="comment-list">
                  <div class="comments-info">
                      <p class="total-comments">{{ commentsAmount }}</p>
                      <edi-comment-filters v-if="!!comments.length"/>
                  </div>
                  <edi-comment-list
                      :content-id="contentId"
                      :comments="comments"
                      :comment-type="commentType"
                  />
              </div>
              <div class="comment-next" v-if="pages > currentPage">
                  <edi-blue-btn @click="updateFilters({ page: currentPage + 1 })">Ver siguientes</edi-blue-btn>
              </div>
          </template>
      </template>
      <span v-else class="comment-spinner">
        <scale-loader :loading="loading" color="#c4071b" height="10px"></scale-loader>
      </span>

    <div id="comment-init-btn" class="comment-init">
      <edi-blue-btn v-if="!showComments" @click="showCommentThread">
          <span v-html="showButtonText"></span>
      </edi-blue-btn>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import ScaleLoader from 'vue-spinner/src/ScaleLoader';
import {
  EdiFeaturedComment,
  EdiCommentSection,
  EdiCommentList,
  EdiCommentFilters,
} from './components';
import { EdiBlueBtn } from '../components';

export default {
  name: 'edi-comments',
  components: {
    EdiFeaturedComment,
    EdiCommentSection,
    EdiCommentList,
    EdiCommentFilters,
    EdiBlueBtn,
    ScaleLoader,
  },
  props: {
    contentId: Number,
    commentable: [Number, Boolean],
    numComments: Number,
    commentType: Number,
  },
  data() {
    return {
      showComments: false,
      loading: false,
      commentsLoaded: false,
    };
  },
  methods: {
    ...mapActions([
      'updateFilters',
      'initContentCommentThread',
    ]),
    hideComments() {
      window.dataLayer.push({
        event: 'comment_interaction',
        eventData: {
          im_action: 'ocultar_comentarios',
          content_id: this.contentId.toString(),
        },
      });

      this.showComments = false;
    },
    async showCommentThread() {
      window.dataLayer.push({
        event: 'comment_interaction',
        eventData: {
          im_action: 'mostrar_comentarios',
          content_id: this.contentId.toString(),
        },
      });

      this.showComments = true;

      if (this.commentsLoaded) {
        return;
      }

      this.loading = true;
      await this.initContentCommentThread(this.contentId);
      this.loading = false;
      this.commentsLoaded = true;
    },
  },
  computed: {
    ...mapGetters([
      'comments',
      'commentsAmount',
      'featuredComment',
      'totalComments',
      'currentPage',
      'pages',
    ]),
    showTotalComments() {
      return this.totalComments ? this.totalComments : this.numComments;
    },
    showButtonText() {
      const text = 'Mostrar comentarios';
      return this.showTotalComments
        ? `${text} <i class="far fa-comment-alt"></i>${this.showTotalComments}`
        : text;
    },
    hideButtonText() {
      const text = 'Ocultar comentarios';
      return this.showTotalComments
        ? `${text} <i class="far fa-comment-alt"></i>${this.showTotalComments}`
        : text;
    },
  },
  mounted() {
    if (window.location.hash === '#edi-comments') {
      this.showCommentThread();
    }
  },
};
</script>

<style>
.fade-enter-active,
.fade-leave-active { transition: opacity .5s; }
.fade-enter,
.fade-leave-to { opacity: 0; }

.comment-spinner {
  display: block;
  margin-bottom: 50px;
}
</style>
